export const LineInfo = ({
  label,
  text,
}: {
  label?: string
  text?: string
}) => {
  return (
    <p className="mr-2">
      <span className="font-bold">{label}</span>: <span>{text}</span>
    </p>
  )
}
